import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import Empty from 'general/components/Empty';
import AppResource from 'general/constants/AppResource';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';
import DashBoard from '../../pages/dashboard';
import ReportLoginStatistics from '../../pages/ReportLoginStatistics';
import ReportNewAccountsStatistics from '../../pages/ReportNewAccountsStatistics';
import OrderStatistics from 'pages/OrderStatistics';
import UserManagement from 'pages/UserManagement';
import AuthorityRole from 'pages/AuthorityRole';
import PermissionRoute from 'general/components/AppRoutes/PermissionRoute';
import Home from 'pages/Home';
import CustomerSet from 'pages/ManageCustomerBase/CustomerSet';
import AddCustomerBase from 'pages/ManageCustomerBase/AddCustomerBase';
import AddCustomer from 'pages/ManageCustomerBase/AddCustomerBase/AddCustomer';
import UseTheService from 'pages/GoodDayStatistics/UseTheService';
import ServiceReviews from 'pages/GoodDayStatistics/ServiceReviews';
import CustormersOverview from 'pages/AnalyzeCustomerBase/CustormersOverview';
import GieoQueLucHao from 'pages/GieoQueLucHao';
import SuDungDichVuTuVi from 'pages/SuDungDichVuTuVi';
import NguoiDungMoi from 'pages/nguoiDungMoi';
import ThanhVienGiaDinh from 'pages/FamilyStatistics';
import CallHistoryReport from 'pages/callHistoryReport';
import HandleLoading from 'components/HandleLoading';
import FamilyMemberReport from 'pages/FamilyMemberReport';
import PhanTichTapKhachHang from 'pages/PhanTichTapKhachHang';
import BaoCaoDoanhThu from 'pages/baoCaoDoanhThu';
import OnlineStore from 'pages/onlineStore';
import KichHoatNangLuong from 'pages/kichHoatNangLuong';
import ThongKeTruyCapAPI from 'pages/thongKeTruyCapApi';
import ThongKeZalo from 'pages/thongKeZalo';
import ThongKeDangKyDichVu from 'pages/thongKeDangKyDichVu';
import CampaignReport from 'pages/CampaignReport';
// import TaoTapKhachHang from 'pages/TaoTapKhachHang';
function Saymee(props) {
  // MARK: --- Props ---
  const { t } = useTranslation();

  return (
    <KT01BaseLayout>
      <div id="saymee-container" className='content d-flex flex-column flex-column-fluid'
        style={{
          fontSize: "15px",
          // fontFamily: "Arial"
        }}>
        <HandleLoading />
        <Routes>

          <Route path="/" element={<Navigate to="Home" />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/salesreport" element={<PermissionRoute path={"salesreport"}><BaoCaoDoanhThu /></PermissionRoute>} />
          {/* <Route path="/salesreport" element={<PermissionRoute path={"salesreport"}><BaoCaoDoanhThu /></PermissionRoute>} /> */}
          <Route path="/ReportLoginStatistics" element={<PermissionRoute path={"ReportLoginStatistics"}><ReportLoginStatistics /></PermissionRoute>} />
          <Route path="/ReportNewAccountsStatistics" element={<PermissionRoute path={"ReportNewAccountsStatistics"}><ReportNewAccountsStatistics /></PermissionRoute>} />
          <Route path="/OrderStatistics" element={<PermissionRoute path={"OrderStatistics"}><OrderStatistics /></PermissionRoute>} />
          <Route path="/UserManagement" element={<PermissionRoute path={"UserManagement"}><UserManagement /></PermissionRoute>} />
          <Route path="/AuthorityRole" element={<PermissionRoute path={"AuthorityRole"}><AuthorityRole /></PermissionRoute>} />
          <Route path="/CustomerSet" element={<PermissionRoute path={"CustomerSet"}><CustomerSet /></PermissionRoute>} />
          <Route path="/AddCustomerBase" element={<PermissionRoute path={"AddCustomerBase"}><AddCustomerBase /></PermissionRoute>} />
          <Route path="/AddCustomer" element={<PermissionRoute path={"AddCustomer"}><AddCustomer /></PermissionRoute>} />
          <Route path="/usetheservice" element={<PermissionRoute path={"usetheservice"}><UseTheService /></PermissionRoute>} />
          <Route path="/servicereviews" element={<PermissionRoute path={"servicereviews"}><ServiceReviews /></PermissionRoute>} />
          <Route path="/CustomersOverview" element={<PermissionRoute path={"CustomersOverview"}><CustormersOverview /></PermissionRoute>} />
          <Route path="/GieoQueLucHao" element={<PermissionRoute path={"GieoQueLucHao"}><GieoQueLucHao /></PermissionRoute>} />
          <Route path="/sudungdichvutuvi" element={<PermissionRoute path={"sudungdichvutuvi"}><SuDungDichVuTuVi /></PermissionRoute>} />
          <Route path="/NguoiDungMoi" element={<PermissionRoute path={"NguoiDungMoi"}><NguoiDungMoi /></PermissionRoute>} />
          <Route path="/baocaozalo" element={<PermissionRoute path={"baocaozalo"}><ThongKeZalo /></PermissionRoute>} />
          <Route path="/ThanhVienGiaDinh" element={<PermissionRoute path={"ThanhVienGiaDinh"}><ThanhVienGiaDinh /></PermissionRoute>} />
          <Route path="/CallHistoryReport" element={<PermissionRoute path={"CallHistoryReport"}><CallHistoryReport /></PermissionRoute>} />
          <Route path="/ApiAccessReport" element={<PermissionRoute path={"ApiAccessReport"}><ThongKeTruyCapAPI /></PermissionRoute>} />
          <Route path="/FamilyMemberReport" element={<PermissionRoute path={"FamilyMemberReport"}><FamilyMemberReport /></PermissionRoute>} />
          <Route path="/PhanTichTapKhachHang" element={<PermissionRoute path={"FamilyMemberReport"}><PhanTichTapKhachHang /></PermissionRoute>} />
          <Route path="/PremiumReport" element={<PermissionRoute path={"PremiumReport"}><ThongKeDangKyDichVu /></PermissionRoute>} />
          <Route path="/OnlineStore" element={<PermissionRoute path={"OnlineStore"}><OnlineStore /></PermissionRoute>} />
          <Route path="/EnergyActivation" element={<PermissionRoute path={"EnergyActivation"}><KichHoatNangLuong /></PermissionRoute>} />
          {/* <Route path="/TaoTapKhachHang" element={<PermissionRoute path={"TaoTapKhachHang"}><TaoTapKhachHang /></PermissionRoute>} /> */}
          <Route path="/campaign-metrics" element={<PermissionRoute path={"campaign-metrics"}><CampaignReport /></PermissionRoute>} />

          <Route
            path="/*"
            element={
              // <Empty
              //   text={t('PageUnderConstruction')}
              //   buttonText={t('Refresh')}
              //   visible={false}
              //   imageEmpty={AppResource.images.errorStates.error404}
              // />
              <div className='container-fluid'>
                <div className='card card-body flex gap-3 h-full'>
                  Đang phát triển
                </div>
              </div>
            }
          />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default Saymee;
